import { useEffect } from 'react';

export default function useDebounceFunction<T>(
  value: T,
  func: (value?: T) => void,
  delay?: number
) {
  useEffect(() => {
    const timer = setTimeout(() => func(value), delay || 700);
    return () => {
      clearTimeout(timer);
    };
  }, [value]);
}
